import { useCallback, useContext } from "react";
import { useQuery } from "react-query";

import { UseQueryProps } from "../../interfaces";
import { apiServiceContext } from "../../api-service-context";
import { QueryKeys } from "../query-keys";
import { IFetchPublicSearchParams } from "../domain";

export const usePublicSearch = <TData = any, TError = any>(
  params: IFetchPublicSearchParams,
  queryOptions: UseQueryProps<TData, TError> = {}
) => {
  const { publicApiService } = useContext(apiServiceContext);
  const queryFn = useCallback(
    () =>
      publicApiService.createCancellableRequest((cancelToken) =>
        publicApiService.getPublicSearch(params, cancelToken)
      ),
    [publicApiService, params]
  );


  return useQuery(QueryKeys.publicSearch(params), queryFn, queryOptions);
};
